import { render, staticRenderFns } from "./SeminarRegistrationFee.vue?vue&type=template&id=40aafbfd&scoped=true&"
import script from "./SeminarRegistrationFee.vue?vue&type=script&lang=js&"
export * from "./SeminarRegistrationFee.vue?vue&type=script&lang=js&"
import style0 from "./SeminarRegistrationFee.vue?vue&type=style&index=0&id=40aafbfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aafbfd",
  null
  
)

export default component.exports